import React, { useEffect, useRef, useState } from "react";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import quote from "../../images/Assets/quote.png";
import Swiper from "swiper";
import "swiper/swiper-bundle.css";

export default function Testimonials() {
  const swiperContainer = useRef(null);
  const [swiperInstance, setSwiperInstance] = useState(null);

  useEffect(() => {
    if (swiperContainer.current) {
      const initialSlidesPerView = getInitialSlidesPerView();
      const swiper = new Swiper(swiperContainer.current, {
        slidesPerView: initialSlidesPerView,
        spaceBetween: 20,
      });
      setSwiperInstance(swiper);

      window.addEventListener("resize", handleResize);

      return () => {
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
        }
        window.removeEventListener("resize", handleResize);
      };
    }
  }, []);

  const handleResize = () => {
    const newSlidesPerView = getInitialSlidesPerView();
    if (swiperInstance) {
      swiperInstance.destroy(true, true);
    }
    const newSwiperInstance = new Swiper(swiperContainer.current, {
      slidesPerView: newSlidesPerView,
      spaceBetween: 20,
    });
    setSwiperInstance(newSwiperInstance);
  };

  const getInitialSlidesPerView = () => {
    const windowWidth = window.innerWidth;
    if (windowWidth < 600) {
      return 1;
    } else if (windowWidth < 900) {
      return 2;
    } else {
      return 3;
    }
  };

  const handleLeftArrowClick = () => {
    if (swiperInstance) {
      swiperInstance.slidePrev();
    }
  };

  const handleRightArrowClick = () => {
    if (swiperInstance) {
      swiperInstance.slideNext();
    }
  };

  return (
    <div className="lg:pl-6 xl:pl-10 pl-28 pt-5 pb-14">
      <div className="bg-[#F4F2FE] text-[14px] text-[#5B2ED9] font-gilroySemibold uppercase w-fit py-0.5 px-2.5 rounded-full">
        Testimonials
      </div>

      <div className="flex items-center justify-between md:pr-6 pr-28 mt-2">
        <div className="sm:text-[22px] md:text-[28px] text-[40px] text-[#0E062A] font-gilroySemibold">
          What our customers say
        </div>

        <div className="flex items-center gap-5">
          <BsArrowLeft className="text-[25px] text-[#0E062A] cursor-pointer" onClick={handleLeftArrowClick} />
          <BsArrowRight
            className="text-[25px] text-[#0E062A] cursor-pointer"
            onClick={handleRightArrowClick}
          />
        </div>
      </div>

      <div ref={swiperContainer} className="swiper-container">
        <div className="grid sm:grid-cols-1 md:grid-cols-2 grid-cols-3 mt-8 swiper-wrapper">
          <div className="swiper-slide bg-[#FBFAFE] border border-[#F1ECFF] text-start px-5 py-5 rounded-2xl">
            <img src={quote} alt="quote" />

            <div className="text-[16px] text-[#544D68] font-gilroyRegular mt-3">
              Lorem ipsum dolor sit amet consectetur. Montes integer ac tincidunt felis ullamcorper. Tristique
              morbi enim orci nibh. Tellus velit quam ut phasellus ut. At fringilla volutpat sit mus.
            </div>

            <div className="text-[16px] text-[#0E062A] font-gilroySemibold mt-4">Amanda</div>
            <div className="text-[14px] text-[#544D68] font-gilroyRegular mt-0.5">CEO of Nescafe</div>
          </div>
          <div className="swiper-slide bg-[#FBFAFE] border border-[#F1ECFF] text-start px-5 py-5 rounded-2xl">
            <img src={quote} alt="quote" />

            <div className="text-[16px] text-[#544D68] font-gilroyRegular mt-3">
              Lorem ipsum dolor sit amet consectetur. Montes integer ac tincidunt felis ullamcorper. Tristique
              morbi enim orci nibh. Tellus velit quam ut phasellus ut. At fringilla volutpat sit mus.
            </div>

            <div className="text-[16px] text-[#0E062A] font-gilroySemibold mt-4">Amanda</div>
            <div className="text-[14px] text-[#544D68] font-gilroyRegular mt-0.5">CEO of Nescafe</div>
          </div>
          <div className="swiper-slide bg-[#FBFAFE] border border-[#F1ECFF] text-start px-5 py-5 rounded-2xl">
            <img src={quote} alt="quote" />

            <div className="text-[16px] text-[#544D68] font-gilroyRegular mt-3">
              Lorem ipsum dolor sit amet consectetur. Montes integer ac tincidunt felis ullamcorper. Tristique
              morbi enim orci nibh. Tellus velit quam ut phasellus ut. At fringilla volutpat sit mus.
            </div>

            <div className="text-[16px] text-[#0E062A] font-gilroySemibold mt-4">Amanda</div>
            <div className="text-[14px] text-[#544D68] font-gilroyRegular mt-0.5">CEO of Nescafe</div>
          </div>
          <div className="swiper-slide bg-[#FBFAFE] border border-[#F1ECFF] text-start px-5 py-5 rounded-2xl">
            <img src={quote} alt="quote" />

            <div className="text-[16px] text-[#544D68] font-gilroyRegular mt-3">
              Lorem ipsum dolor sit amet consectetur. Montes integer ac tincidunt felis ullamcorper. Tristique
              morbi enim orci nibh. Tellus velit quam ut phasellus ut. At fringilla volutpat sit mus.
            </div>

            <div className="text-[16px] text-[#0E062A] font-gilroySemibold mt-4">Amanda</div>
            <div className="text-[14px] text-[#544D68] font-gilroyRegular mt-0.5">CEO of Nescafe</div>
          </div>
          <div className="swiper-slide bg-[#FBFAFE] border border-[#F1ECFF] text-start px-5 py-5 rounded-2xl">
            <img src={quote} alt="quote" />

            <div className="text-[16px] text-[#544D68] font-gilroyRegular mt-3">
              Lorem ipsum dolor sit amet consectetur. Montes integer ac tincidunt felis ullamcorper. Tristique
              morbi enim orci nibh. Tellus velit quam ut phasellus ut. At fringilla volutpat sit mus.
            </div>

            <div className="text-[16px] text-[#0E062A] font-gilroySemibold mt-4">Amanda</div>
            <div className="text-[14px] text-[#544D68] font-gilroyRegular mt-0.5">CEO of Nescafe</div>
          </div>
          <div className="swiper-slide bg-[#FBFAFE] border border-[#F1ECFF] text-start px-5 py-5 rounded-2xl">
            <img src={quote} alt="quote" />

            <div className="text-[16px] text-[#544D68] font-gilroyRegular mt-3">
              Lorem ipsum dolor sit amet consectetur. Montes integer ac tincidunt felis ullamcorper. Tristique
              morbi enim orci nibh. Tellus velit quam ut phasellus ut. At fringilla volutpat sit mus.
            </div>

            <div className="text-[16px] text-[#0E062A] font-gilroySemibold mt-4">Amanda</div>
            <div className="text-[14px] text-[#544D68] font-gilroyRegular mt-0.5">CEO of Nescafe</div>
          </div>
          <div className="swiper-slide bg-[#FBFAFE] border border-[#F1ECFF] text-start px-5 py-5 rounded-2xl">
            <img src={quote} alt="quote" />

            <div className="text-[16px] text-[#544D68] font-gilroyRegular mt-3">
              Lorem ipsum dolor sit amet consectetur. Montes integer ac tincidunt felis ullamcorper. Tristique
              morbi enim orci nibh. Tellus velit quam ut phasellus ut. At fringilla volutpat sit mus.
            </div>

            <div className="text-[16px] text-[#0E062A] font-gilroySemibold mt-4">Amanda</div>
            <div className="text-[14px] text-[#544D68] font-gilroyRegular mt-0.5">CEO of Nescafe</div>
          </div>
          <div className="swiper-slide bg-[#FBFAFE] border border-[#F1ECFF] text-start px-5 py-5 rounded-2xl">
            <img src={quote} alt="quote" />

            <div className="text-[16px] text-[#544D68] font-gilroyRegular mt-3">
              Lorem ipsum dolor sit amet consectetur. Montes integer ac tincidunt felis ullamcorper. Tristique
              morbi enim orci nibh. Tellus velit quam ut phasellus ut. At fringilla volutpat sit mus.
            </div>

            <div className="text-[16px] text-[#0E062A] font-gilroySemibold mt-4">Amanda</div>
            <div className="text-[14px] text-[#544D68] font-gilroyRegular mt-0.5">CEO of Nescafe</div>
          </div>
          <div className="swiper-slide bg-[#FBFAFE] border border-[#F1ECFF] text-start px-5 py-5 rounded-2xl">
            <img src={quote} alt="quote" />

            <div className="text-[16px] text-[#544D68] font-gilroyRegular mt-3">
              Lorem ipsum dolor sit amet consectetur. Montes integer ac tincidunt felis ullamcorper. Tristique
              morbi enim orci nibh. Tellus velit quam ut phasellus ut. At fringilla volutpat sit mus.
            </div>

            <div className="text-[16px] text-[#0E062A] font-gilroySemibold mt-4">Amanda</div>
            <div className="text-[14px] text-[#544D68] font-gilroyRegular mt-0.5">CEO of Nescafe</div>
          </div>
        </div>
      </div>
    </div>
  );
}
